import React from "react";
import { Button, Modal, Popconfirm, Row, Table } from "antd";
import { DeleteOutlined, FolderViewOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import Constants from "../../utils/constants";

const { Column } = Table;

function HistoriqueRapprochementsModal({ open, onCancel, rapprochementsBancaires, onDelete }) {
  return (
    <Modal
      width={800}
      open={open}
      title="Historique des rapprochements bancaires validés"
      onCancel={onCancel}
    >
      <Row>
        <Table style={{width:'100%'}} rowKey="rapprochement_bancaire_id" dataSource={rapprochementsBancaires}>
          <Column
            title="Date relevé"
            dataIndex="rapprochement_bancaire_date_releve"
            key="releve"
            render={(date) => dayjs(date, "YYYY-MM-DD").format("DD/MM/YYYY")}
          />
          <Column
            title="Montant relevé"
            dataIndex="rapprochement_bancaire_montant_releve"
            key="montant"
            align="right"
            render={(montant) =>
              parseFloat(montant).toLocaleString("fr-FR", {
                style: "currency",
                currency: "EUR",
              })
            }
          />
          <Column
            title="Date validation"
            align="center"
            dataIndex="rapprochement_bancaire_date_validation"
            key="validation"
            render={(date) => dayjs(date, "YYYY-MM-DD").format("DD/MM/YYYY")}
          />
          <Column
            title="Afficher"
            align="center"
            dataIndex="rapprochement_bancaire_id"
            key="x"
            render={(id) => (
              <Button href={`${Constants.directory}rapprochements/${id}.pdf`} target="_blank">
                <FolderViewOutlined />
              </Button>
            )}
          />
          <Column
            title="Supprimer"
            align={"center"}
            dataIndex="rapprochement_bancaire_id"
            key="y"
            render={(id) => (
              <Popconfirm
                title="Êtes vous sûr de vouloir supprimer ce rapprochement bancaire ?"
                onConfirm={() => onDelete(id)}
              >
                <Button>
                  <DeleteOutlined />
                </Button>
              </Popconfirm>
            )}
          />
        </Table>
      </Row>
    </Modal>
  );
}

export default HistoriqueRapprochementsModal;
